import { PrimaryAnnotatedType } from '@/components/annotated-type';
import { HorizontalBarChart } from '@/components/bar-chart/horizontal';
import { ScrollGraphic, ScrollRoot, ScrollStep, ScrollSteps } from '@/components/microstory/scroll';
import { StoryText } from '@/components/microstory/text';
import { useNumberFormatting } from '@/utils/use-number-formatting';
import { t, Trans } from '@lingui/macro';
import { useState } from 'react';

type UnderPressureCh1Props = {
  data: UnderPressureData['pressure_median'];
};

export function UnderPressureCh1(props: UnderPressureCh1Props) {
  const { data } = props;

  const formatPercentage = useNumberFormatting('percent');

  const [chartVisible, setChartVisible] = useState(false);

  const handleStepEnter = () => {
    setChartVisible(true);
  };

  return (
    <ScrollRoot>
      <ScrollGraphic>
        <HorizontalBarChart
          visible={chartVisible}
          label={t({
            id: 'under-pressure.chapter-1.chart-label',
            message:
              '% of young people who believe children today face more pressure to succeed than their parents did',
          })}
          data={[
            {
              label: t({ id: 'under-pressure.ch1.chart.more', message: 'More pressure' }),
              value: data.more,
            },
            {
              label: t({ id: 'under-pressure.ch1.chart.less', message: 'Less pressure' }),
              value: data.less,
            },
          ]}
          formatValue={formatPercentage}
        />
      </ScrollGraphic>
      <ScrollSteps offset={0.5} onStepEnter={handleStepEnter} hasGraphic>
        <ScrollStep>
          <StoryText>
            <Trans id="under-pressure.chapter-1.text-1">
              On average, 59% of <PrimaryAnnotatedType>young people</PrimaryAnnotatedType> believe
              children today face more pressure to succeed than their parents did as kids.
            </Trans>
          </StoryText>
        </ScrollStep>
      </ScrollSteps>
    </ScrollRoot>
  );
}
